<template>
  <div class="p-4">
    <div v-if="photos.length > 0" class="mb-6">
      <div class="relative aspect-video bg-gray-100 rounded-lg overflow-hidden mb-3">
        <img :src="photos[activePhoto]" :alt="product.name" class="w-full h-full object-contain">
        <button class="absolute left-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/40 text-white flex items-center justify-center" @click="previousPhoto">◀</button>
        <button class="absolute right-2 top-1/2 -translate-y-1/2 w-8 h-8 rounded-full bg-black/40 text-white flex items-center justify-center" @click="nextPhoto">▶</button>
      </div>
      <div class="flex gap-2 overflow-x-auto">
        <div
          v-for="(photo, index) in photos" :key="index"
          class="w-16 h-16 flex-shrink-0 rounded border-2 cursor-pointer overflow-hidden"
          :class="activePhoto === index ? 'border-primary' : 'border-gray-200'"
          @click="setActivePhoto(index)"
        >
          <img :src="photo" class="w-full h-full object-cover">
        </div>
      </div>
    </div>

    <div v-if="productDetail" class="mb-6">
      <h3 class="text-lg font-bold text-gray-800 mb-3">Product Description</h3>
      <div v-if="productDetail.specifications && productDetail.specifications.length" class="grid grid-cols-2 gap-2 mb-4">
        <div v-for="(spec, index) in productDetail.specifications" :key="index" class="flex border-b border-gray-100 pb-1">
          <span class="text-gray-500 text-sm w-24 flex-shrink-0">{{ spec.label }}</span>
          <span class="text-gray-800 text-sm">{{ spec.value }}</span>
        </div>
      </div>
      <p v-if="productDetail.introduction" class="text-gray-600 text-sm">{{ productDetail.introduction }}</p>
    </div>

    <button class="w-full py-3 bg-primary hover:bg-primary-dark text-white rounded-lg transition-colors text-lg min-h-[44px]" @click="$emit('inquiry', product.id)">
      Inquiry Now
    </button>
  </div>
</template>

<script>
export default {
  name: 'ProductDetail',
  props: {
    product: {
      type: Object,
      required: true
    },
    productDetail: {
      type: Object,
      required: true
    },
    activePhoto: {
      type: Number,
      default: 0
    }
  },
  computed: {
    photos() {
      const detail = this.productDetail;
      if (!detail) return [];
      return [detail.imageUrl1, detail.imageUrl2, detail.imageUrl3, detail.imageUrl4].filter(Boolean);
    }
  },
  methods: {
    setActivePhoto(index) {
      this.$emit('update:activePhoto', index);
    },
    previousPhoto() {
      const next = this.activePhoto - 1 >= 0 ? this.activePhoto - 1 : this.photos.length - 1;
      this.$emit('update:activePhoto', next);
    },
    nextPhoto() {
      const next = this.activePhoto + 1 < this.photos.length ? this.activePhoto + 1 : 0;
      this.$emit('update:activePhoto', next);
    }
  }
}
</script>

<style scoped>
</style>
